window.addEventListener('load', function() {
    let swiperOptions = {
            slidesPerView: 2,
            spaceBetween: 15,
            breakpoints: {
                750: {
                slidesPerView: 1,
                spaceBetween: 20
                }  
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            }
    };
    
    const ShopTheLookSlider = new Swiper('.ShopTheLookSlider', swiperOptions);
});